import isotope from 'isotope-layout';

class bhs_teamgrid {

  static get selectors() {
    return {
      teamQlCta: '.team-ql-cta',
      teamLightboCloseBtn: '.teamLightbox-close-btn',
      teamCta: '.team-cta',
      teamItem : '.team-item',
      teamLightboxC: '.teamLightboxC',
      teamImage: '.team-image',
      body:'.bodyPushTeam-open',
      teamLightboxBlock: '.teamLightbox-block',
      teamgrid: '.team-grid',
      teamitem: '.team-item'
    };
  }

  static get classes() {
    return {
      plus: 'plus',
      minus: 'minus',
      active: 'active',
      columnWidth: 25
    };
  }



    static init() {
      var grid = document.querySelector(this.selectors.teamgrid);

var iso = new isotope( grid, {
  // options...
  itemSelector: this.selectors.teamitem,
  masonry: {
    columnWidth: this.classes.columnWidth
  }
});

      $(this.selectors.teamCta).click(function() {
        $(this).find('.team-ql-cta').toggleClass('plus');
        $(this).find('.team-ql-cta').toggleClass('minus');
        $(this).parent().find('.team-des').toggleClass('active');
      });

    //   $('.team-image').click(function() {
    //    $('.teamLightboxC').addClass('active');
    //    $('.bodyPushTeam-open').addClass('active');
    //    $('.teamLightbox-block').addClass('active');

    //     var imageAlt = $(this).parent().find('.team-image').attr('alt');
    //     var teamImg = $(this).parent().find('.team-image').attr('src');
    //     var teamName = $(this).parent().find('.team-name').text();
    //     var teamPosition = $(this).parent().find('.team-position').text();
    //     var teamDesLong = $(this).parent().find('.team-des-long').text();

    //     $('.teamLightbox-img').attr('src', teamImg ).attr('alt', imageAlt );
    //     $('.teamLightbox-name').text(teamName);
    //     $('.teamLightbox-title').text(teamPosition);
    //     $('.teamLightbox-content').text(teamDesLong);


    // });

      $(this.selectors.teamLightboxC).on('click', (e) => {
  
        $(this.selectors.body).removeClass(this.classes.active);
        
       //
       $(this.selectors.teamLightboxBlock).removeClass(this.classes.active);
       $(this.selectors.teamLightboxC).removeClass(this.classes.active);
        
      });




    // filter items on button click
    // $('.filter-button-group').on( 'click', 'button', function() {
    //     var filterValue = $(this).attr('data-filter');
    //     $grid.isotope({ filter: filterValue });
    // });

    }
  }
  
  module.exports = bhs_teamgrid;
  